export {};

declare global {
    interface String {
        format(...params: any[]);
        toBoolean(): boolean;
    }
}

function format(this: string, ...params: any[]): string {
    if (this == null) {
        return null;
    }
    if (params == null) {
        return this;
    }
    let value = this;
    for (let i = 0; i < params.length; i++) {
        value = value.replace(`{${i}}`, `${params[i]}`);
    }
    return value;
}

String.prototype.format = format;

function toBoolean(this: string): boolean {
    const value = this.toLowerCase();
    switch (value) {
        case 'true':
        case '1':
        case 'on':
        case 'yes':
            return true;
        default:
            return false;
    }
}
String.prototype.toBoolean = toBoolean;
